import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalComponent } from '@components/modal/modal.component';

@Component({
  selector: 'analysis-finish',
  templateUrl: './analysis-finish.component.html',
  styleUrls: ['./analysis-finish.component.scss'],
})
export class AnalysisFinishComponent implements OnInit {
  constructor(
    private router: Router,
    public dialogFinish: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}

  closeDialog(event?: string): void {
    const close = {
      timeout: () => (this.dialogFinish.close(), this.router.navigateByUrl('/')),
      keepAnalysis: () => this.dialogFinish.close({finalize: false}),
      completed: () => this.dialogFinish.close({finalize: true}),
    };
    return close[event]();
  }
}
